import React from "react";

// MUI
import { Drawer, Box, Stack, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
  width?: string;
}

const DrawerComponent = ({
  open,
  onClose,
  children,
  title,
  width = "90vw",
}: DrawerProps) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "&.MuiDrawer-root": {
          zIndex: 1201,
        },
      }}
    >
      <Box sx={{ width: { xs: "90vw", sm: width } }}>
        <Stack direction="row" alignItems="center" pl={2} pt={1} pb={1} pr={2}>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
          <Box>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Stack>
        {children}
      </Box>
    </Drawer>
  );
};

export default DrawerComponent;
